module.exports = __webpack_public_path__ + "static/img/Sitecutfigure3.f581c94.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/aboutUs/Sitecutfigure3.jpg
// module id = k1eL
// module chunks = 1